/*
  브라우저 로컬 스토리지에 저장될 키 값 모음.
*/
const localStorageKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
};

export default localStorageKeys;
